/*
 * @Author: mazhigang
 * @Date: 2023-07-03 15:10:18
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-02 22:21:58
 */
/*
 * @Author: mazhigang
 * @Date: 2023-07-03 15:10:18
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-15 16:46:27
 */
function moneyFormat(num) {
  if (!num) {
    num = 0;
  }
  num = parseFloat((num + "").replace("/[^d.-]/g", "")).toFixed(2) + "";
  return num;
}
function addComma(num = 0) {
  return num.toString().replace(/\d+/, function(n) {
    return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  });
}
function maxTime(min) {
  let minTime = "";
  if (min < 60) {
    minTime = min + "分钟";
  } else {
    let hour = Math.trunc(min / 60);
    if (hour < 24) {
      let middle = min - parseInt(hour * 60);
      minTime = hour + "小时" + middle + "分钟";
    } else {
      let day = Math.trunc(min / 1440);
      hour = Math.trunc((min - 1440 * day) / 60);
      let middle = min - (1440 * day + 60 * hour);
      if (middle == 0 && hour != 0) {
        minTime = day + "天" + hour + "小时";
      } else if (hour == 0) {
        minTime = day + "天";
      } else {
        minTime = day + "天" + hour + "小时" + middle + "分钟";
      }
    }
  }
  return minTime;
}
function maxTime1(time) {
  let h = parseInt((time / 60 / 60) % 24);
  h = h < 10 ? "0" + h : h;
  let m = parseInt((time / 60) % 60);
  m = m < 10 ? "0" + m : m;
  let s = parseInt(time % 60);
  s = s < 10 ? "0" + s : s;
  // 作为返回值返回
  return h + ":" + m + ":" + s;
}
function maskPhoneNumber(phoneNumber) {
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}
export default {
  maxTime,
  maxTime1,
  moneyFormat,
  addComma,
  maskPhoneNumber
};



// WEBPACK FOOTER //
// ./src/filter.js